<template>
  <div>
    <table class="table border-light border-primary table-responsive mt-3 w-100 d-block d-md-table">
      <thead>
      <tr>
        <th>USER</th>
        <th>ROLE</th>
        <th class="text-right">
          ACTIONS
        </th>
      </tr>
      </thead>
      <tr v-for="user in users" :key="user.id">
        <td>{{ user.email }}</td>
        <td>Admin</td>
        <td class="text-right">
          <button class="btn btn-xs btn-light mr-2">
            <i class="dripicons-document-edit" />
          </button>
          <button class="btn btn-xs btn-light">
            <i class="dripicons-trash" />
          </button>
        </td>
      </tr>
      <tr v-if="show">
        <td>
          <input v-model="email"  type="email" name="email" placeholder="Enter gmail"
                 class="form-control input-sm">
          <!--<small v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</small>-->
        </td>
        <td>Admin</td>
        <td class="text-right">
          <div class="btn-group" role="group" aria-label="Action">
            <button class="btn btn-xs btn-light mr-2" @click="show = false">
              Cancel
            </button>
            <button class=" btn btn-xs btn-success" @click="add">
              Save
            </button>
          </div>
        </td>
      </tr>
    </table>
    <div class="text-right">
      <button v-if="show == false" class="btn btn-primary" @click="show = true">
        Add member
      </button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Team",
    data: function () {
      return {
        email: '',
        show: false,
        users: []

      }

    },
    mounted: function () {
      this.list()
    },
    methods: {

      add: function () {
        let vm = this
       // if (this.errors.has('email')) return
        this.$http.post(this.$config.api + 'user/add', { email: this.email }).then(function (res) {
          if (res.data != true) {
            vm.$swal('Email existed')
            return
          }
          vm.show = false
          vm.email = ''
          vm.list()
        })

      },
      remove: function () {

      },
      list: function () {
        let vm = this
        this.$http.get(this.$config.api + 'user').then(function (res) {
          vm.users = res.data.results
        })
      }
    }
  }
</script>

<style scoped>

</style>